import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getZonesAPI } from './api';

export const GET_ZONES = 'getZones';

export function useGetZones() {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery([
    GET_ZONES, tenantId,
  ], () => getZonesAPI());

  return {
    zones: data?.zones || [],
    isLoading,
    isFetching,
    isError,
  };
}

